<template>
  <router-link
    v-if="isRoute"
    :class="$style.sidebar"
    :to="pathTo"
  >
    <span :class="$style.text">
      <slot />
    </span>
  </router-link>
  <a
    v-else
    :class="$style.sidebar"
    :href="pathTo"
    aria-label="Кнопка слайдера"
  >
    <span :class="$style.text">
      <slot />
    </span>
  </a>
</template>

<script>
export default {
  name: 'BaseSideButton',
  props: {
    pathTo: {
      type: String,
      default: '/',
    },
    type: {
      type: String,
      default: 'link',
    },
  },
  methods: {
    isRoute() {
      return this.type === 'route';
    },
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/helpers';

.sidebar {
  position: fixed;
  z-index: $zidx-over;
  bottom: 10%;
  right: 0;
  padding: 15px 40px;
  background: $red-light;
  box-shadow: 0 0 9px 0 rgba(247, 80, 80, 0.7);
  text-decoration: none;
  transform-origin: right top;
  transform: rotate(-270deg);

  @include media('<=phone') {
    padding: 12px 17px;
  }
}

.text {
  @include set-fz-lh(17, 23);
  font-weight: bold;
  text-transform: uppercase;
  color: $white;
  white-space: nowrap;

  @include media('<=phone') {
    @include set-fz-lh(12, 16);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseSideButton.vue